import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const OTHER_HABITATS: Layer = {
  id: "other_habitats",
  layerType: ConstraintsLayerType,
  title: "Protected habitats",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-leaf-line",
  description:
    "Although not classified as irreplaceable, these habitats will still represent a significant constraint for development or opportunity for biodiversity enhancement",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.HABITATS,
    categorySchema: [{ key: "open_mosaic_habitats" }, { key: "priority_habitat_inventory" }],
  },
};
